export var notice = ['codeInputLimitReached', 'TemporaryBlock', 'PermanentBlock'];